import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Dropdown, Grid, Input } from 'semantic-ui-react';
import Mrp from '../../PurchaseAndStock/PurchaseDetails/mrp';
import Remarks from './remarks';
import DelivaryDate from './deliverydate';
import ChangeStatus from './changestatus';
import Checkbox from '@material-ui/core/Checkbox';
import ChangeCheckbox from './multiplestatuschange';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Generatequotation from './generatequotation';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loadings';
import ReadCookie from '../../../functions/readcookies';
import PartView from './partview';
import Analysis from './analysis';
import Customerdetails from '../../others/customerdetails';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class Title extends React.Component {

  state = {
    fullWidth: true, maxWidth: 'lg', maxWidth1: 'xs',
    filter: ['Waiting'], checkBox: [], check30: true,
    value30: 100, customerOrders: false
  }

  clicked(id, customer_id) {
    this.setState({ open: true, mid: id, customerId: customer_id })
    let data = this.props.data;
    let checkBox = [];
    data.map((x) => {
      if (id == x.mid) {
        checkBox.push({id: x.id, checkbox: false, qty: x.qty, uprice: x.uprice, tax: x.tax, mid: x.mid })
      }
    })
    this.setState({ checkBox: checkBox })
  }

  checkBoxUpdate(data) { this.setState({ checkBox: data }) }

  filter = (f, { value }) => { this.setState({ filter: value }); this.props.upDateStatus(value); }

  calculateTotal(customer) {
    let masterData = this.props.masterData;
    let filter = this.state.filter;
    let total = 0;
    masterData.map((m) => {
      if (m.cid == customer) {
        filter.map((f) => {
          if (f == 'Waiting') { if (Number(m.waiting) > 0) { total = total + Number(m.waiting_amount); } }
          if (f == 'Approved') { if (Number(m.approved) > 0) { total = total + Number(m.approved_amount); } }
          if (f == 'Prior Order') { if (Number(m.prior_order) > 0) { total = total + Number(m.prior_order_amount); } }
          if (f == 'Delivered') { if (Number(m.delivered) > 0) { total = total + Number(m.delivered_amount); } }
          if (f == 'Pending For Delivery') { if (Number(m.pending_for_delivery) > 0) { total = total + Number(m.pending_for_delivery_amount); } }
          if (f == 'Canceled') { if (Number(m.canceled) > 0) { total = total + Number(m.canceled_amount); } }
        })
      }
      if (customer == '') {
        filter.map((f) => {
          if (f == 'Waiting') { if (Number(m.waiting) > 0) { total = total + Number(m.waiting_amount); } }
          if (f == 'Approved') { if (Number(m.approved) > 0) { total = total + Number(m.approved_amount); } }
          if (f == 'Prior Order') { if (Number(m.prior_order) > 0) { total = total + Number(m.prior_order_amount); } }
          if (f == 'Delivered') { if (Number(m.delivered) > 0) { total = total + Number(m.delivered_amount); } }
          if (f == 'Pending For Delivery') { if (Number(m.pending_for_delivery) > 0) { total = total + Number(m.pending_for_delivery_amount); } }
          if (f == 'Canceled') { if (Number(m.canceled) > 0) { total = total + Number(m.canceled_amount); } }
        })
      }
    })
    return '₹'+Number(total).toFixed(2);
  }

  generatequotation() {
    let context = this;
    let orderData = this.state.checkBox;
    let value1 = 0;
    orderData.map((v) => { if (v.checkbox == true) { value1 = 1; } })
    if (value1 == 0) { alert('Select the Checkbox!!!'); return; }
    let order = [];
    orderData.map((c) => { if (c.checkbox == true) { order.push(c); } })
    let cook = (ReadCookie("vaigai"));
    let id = cook.id; let delivery = 0;
    let customerId = this.state.customerId;
    order = JSON.stringify(order);
    this.setState({ load: true, message: 'Update Quotation' })
    let url = Server() + 'orderstatus/generatequotation.php';
    $.ajax({
      type: 'POST',
      data: { 'orders': order, 'id': customerId, 'created_by': id, 'delivery': delivery },
      url: url,
      success: function(data) {
        if (data >= 1) {
          context.props.getExecutiveId();
          context.setState({ dialog: false, load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false })
      }
    })
  }

  changeStatus(value) {
    let context = this;
    if (this.props.placeorderedit == 'none') { alert('You are not allow to change status!!!!'); return; }
    let orderData = this.state.checkBox;
    let value1 = 0;
    orderData.map((v) => {
      if (v.checkbox == true) { value1 = 1; }
    })
    if (value1 == 0) { alert('Select the Checkbox!!!'); return; }
    let orginalData = this.props.data;
    let dataa = this.state.checkBox;
    orderData = JSON.stringify(orderData);
    this.setState({ load: true, message: 'Update Status' });
    $.ajax({
      type: 'POST',
      data: { 'array': orderData, 'status': value },
      url: Server() + 'placeorder/updateorderstatusmultiple.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ checkBox: [], openChangeStatus: false, open: false, load: false })
          context.props.getExecutiveId();
        }
        else {
          alert('Error');
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false })
      }
    })
  }

  stockchange = (id) => event => {
    if (0 >= event.target.value) {
      alert('0 Stock is not accept');
      return;
    }
    let data = this.state.checkBox;
    let orignaldata = this.props.data;
    data.map((c) => {
      orignaldata.map((v) => {
        if (id == c.id && id == v.id) {
          if (Number(v.qty) >= Number(event.target.value)) {
            c.qty = event.target.value;
          }
          else {
            alert('Stock is more then purchase stock!!!!')
          }
        }
      })
    })
    this.setState({ checkBox: data })
  }

  handleChange = (id) => event => {
    let data = this.state.checkBox;
    data.map((c) => {
      if (id == c.id) { c.checkbox = event.target.checked; }
    })
    this.setState({ checkBox: data })
  };


  handleChangeAll = () => event => {
    let data = this.state.checkBox;
    data.map((c) => { c.checkbox = event.target.checked; })
    this.setState({ checkBox: data })
  }

  total() {
    let data = this.state.checkBox;
    let total = 0;
    data.map((c) => {
      if (c.checkbox == true) {
        let uprice = c.uprice; let tax = c.tax; let qty = c.qty;
        try {
          uprice = Number(uprice); tax = Number(tax); qty = Number(qty);
        } catch (e) {
        }
        total = total + ((uprice * qty) + (((uprice * qty) * tax)/100));
      }
    })
    return total.toFixed(2);
  }

  overallTotal() {
    let data = this.state.checkBox;
    let total = 0;
    data.map((c) => {
      let uprice = c.uprice; let tax = c.tax; let qty = c.qty;
      try {
        uprice = Number(uprice); tax = Number(tax); qty = Number(qty);
      } catch (e) {
      }
      total = total + ((uprice * qty) + (((uprice * qty) * tax)/100));
    })
    return total.toFixed(2);
  }

  checkBoxEvent = event => { this.props.updateCustomerOrders(event.target.checked); this.setState({ customerOrders: event.target.checked }) }

  render() {
    let i = 1;
    let j = 0;
    let filter = this.state.filter;
    let menuOption = [
      { key: 'Waiting', text: 'Waiting', value: 'Waiting' },
      { key: 'Approved', text: 'Approved', value: 'Approved' },
      { key: 'Pending For Delivery', text: 'Pending For Delivery', value: 'Pending For Delivery' },
      { key: 'Prior Order', text: 'Prior Order', value: 'Prior Order' },
      { key: 'Delivered', text: 'Delivered', value: 'Delivered' },
      { key: 'Canceled', text: 'Canceled', value: 'Canceled' },
    ];
    let checkBox = 'checkBox';
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <div style={{display: 'flex'}}>
              <div>
                <Dropdown multiple id="Statue" onChange={this.filter} search selection fluid options={menuOption}
                  value={this.state.filter} />
              </div>
              <div style={{marginLeft: '1%'}}>
                <FormControlLabel
                  value="bottom"
                  control={<Checkbox onChange={this.checkBoxEvent} checked={this.state.customerOrders} />}
                  label="Customer Order"
                  labelPlacement="right"
                />

              </div>
              <div style={{marginLeft: '1%'}}><PartView placeorderedit={this.props.placeorderedit} /></div>
              <div style={{marginLeft: '1%'}}><Analysis /></div>
              <div style={{marginLeft: '1%'}}>
                <Generatequotation placeorderedit={this.props.placeorderedit}
                  customer={this.props.customer} data={this.props.data}
                  updateData={this.props.updateData} menuPermission={this.props.menuPermission}
                  seprateMaterDetails={this.props.seprateMaterDetails} />
              </div>
              <div style={{marginLeft: '1%'}}>
                <div align='right' style={{fontSize: 17, color: '#4574A3'}}>{this.calculateTotal(this.props.customer)}</div>
              </div>
            </div>
          </Grid.Column>
        </Grid><br/>
        <table width="100%" id='table'>
          <tbody>
            <tr style={{height: 15, backgroundColor: '#abb119', color: 'white'}}>
              <th><center>Si</center></th>
              <th><center>Voucher No</center></th>
              <th><center>Customer</center></th>
              <th><center>Created</center></th>
              <th><center>Executive</center></th>
              <th><center>Delivery</center></th>
              <th><center>Items</center></th>
              <th><center>Status</center></th>
              <th><center>{'Amount'}</center></th>
              <th><center>{'Remarks'}</center></th>
            </tr>
          </tbody>
          { this.props.masterData.map((c) => {
              let csize = 13; let tsize = 13; let cesize = 13; let esize = 13;
              let created_executive_id = c.created_executive_id;
              if (c.created_executive_id == 0 || c.created_executive_id == '0') { created_executive_id = 'Self'; }
              let row = (
                <tr id='tbody'>
                  <td onClick={this.clicked.bind(this, c.mid, c.customer_id)}><center>{i++}</center></td>
                  <td onClick={this.clicked.bind(this, c.mid, c.customer_id)}>{c.voucher_no}</td>
                  <td><Customerdetails customerName={c.customer_name} customerId={c.customer_id} /></td>
                  <td onClick={this.clicked.bind(this, c.mid, c.customer_id)}><div style={{fontSize: cesize}}>{c.created_executive_name}{'('+created_executive_id+')'}</div></td>
                  <td onClick={this.clicked.bind(this, c.mid, c.customer_id)}><center><div style={{fontSize: esize}}>{c.executive_name}{'('+c.executive_id+')'}</div></center></td>
                  <td><center><DelivaryDate placeorderedit={this.props.placeorderedit} exp_del={c.exp_del} updatemasterData={this.props.updatemasterData} masterData={this.props.masterData} mid={c.mid} /></center></td>
                  <td onClick={this.clicked.bind(this, c.mid, c.customer_id)}><center>{c.waiting}</center></td>
                  <td>
                    <ChangeStatus placeorderedit={this.props.placeorderedit} seprateMaterDetails={this.props.seprateMaterDetails} status={c.status} updatemasterData={this.props.updatemasterData}
                      masterData={this.props.masterData} mid={c.mid} data={this.props.data} />
                  </td>
                  <td onClick={this.clicked.bind(this, c.mid, c.customer_id)}><div style={{textAlign: 'right'}}>{'₹'+Math.round(c.waiting_amount)}</div></td>
                  <td><center><Remarks placeorderedit={this.props.placeorderedit} updatemasterData={this.props.updatemasterData} masterData={this.props.masterData} mid={c.mid} /></center></td>
                </tr>
              );
              if (this.props.customer == '') {
                return (
                  <tbody>
                    {
                      filter.map((d) => {
                        if (d == 'Waiting') { if (Number(c.waiting) > 0) { return row; } }
                        if (d == 'Approved') { if (Number(c.approved) > 0) { return row; } }
                        if (d == 'Prior Order') { if (Number(c.prior_order) > 0) { return row; } }
                        if (d == 'Delivered') { if (Number(c.delivered) > 0) { return row; } }
                        if (d == 'Pending For Delivery') { if (Number(c.pending_for_delivery) > 0) { return row; } }
                        if (d == 'Canceled') { if (Number(c.canceled) > 0) { return row; } }
                      })
                    }
                  </tbody>
                )
              }
              else {
                return (
                  <tbody>
                    {
                      filter.map((d) => {
                        if (d == 'Waiting') { if ((Number(c.waiting) > 0) && c.customer_id == this.props.customer) { return row; } }
                        if (d == 'Approved') { if ((Number(c.approved) > 0) && c.customer_id == this.props.customer) { return row; } }
                        if (d == 'Prior Order') { if ((Number(c.prior_order) > 0) && c.customer_id == this.props.customer) { return row; } }
                        if (d == 'Delivered') { if ((Number(c.delivered) > 0) && c.customer_id == this.props.customer) { return row; } }
                        if (d == 'Pending For Delivery') { if ((Number(c.pending_for_delivery) > 0) && c.customer_id == this.props.customer) { return row; } }
                        if (d == 'Canceled') { if ((Number(c.canceled) > 0) && c.customer_id == this.props.customer) { return row; } }
                      })
                    }
                  </tbody>
                )
              }
            })
          }
        </table>
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}  open={this.state.open}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Orders</DialogTitle>
          <DialogContent>
            <div style={{display: 'flex', marginLeft: '75%'}}>
              <div style={{fontSize: 18, color: '#416990'}}>{'Rs.'+this.overallTotal()}</div>
              <div style={{fontSize: 18, color: '#416990', marginLeft: '4%'}}>{'Rs.'+this.total()}</div>
            </div>
            <table width='100%' id='table'>
              <tr>
                <th id='th'><center>Sino</center></th>
                <th id='th'><center>Partno</center></th>
                <th id='th'><center>Spare Name</center></th>
                <th id='th'><center>Qty</center></th>
                <th id='th'><center>Status</center></th>
                <th id='th'><center>Total</center></th>
                <th id='th'><center>Info</center></th>
                <th id='th' style={{width: '12%'}}><center>Custome</center></th>
                <th id='th' style={{width: '8%'}}><center> <Checkbox onChange={this.handleChangeAll()} value="Check" /> </center></th>
              </tr>
              { this.props.data.map((c) => {
                return(
                  <tbody>
                    {
                      this.state.checkBox.map((m) => {
                        if (c.id == m.id) {
                          j++;
                          return (
                            <tr>
                              <td><center>{j}</center></td>
                              <td>{(c.spare_name)?(<div>{c.partno}</div>):(<div>Other Charge</div>)}</td>
                              <td>{(c.spare_name)?(<div>{c.spare_name}</div>):(<div>Other Charge</div>)}</td>
                              <td><center>{c.qty}</center></td>
                              <td>
                                { (c.spare_name) ?
                                  (
                                    <ChangeStatus placeorderedit={this.props.placeorderedit} seprateMaterDetails={this.props.seprateMaterDetails} status={c.status}
                                      updatemasterData={this.props.updatemasterData} from='singleStatus'
                                      masterData={this.props.masterData} mid={c.id} data={this.props.data} />
                                  ) : ( <div>Other Charge</div> )
                                }
                              </td>
                              <td>{c.totprice}</td>
                              <td>
                                { (c.spare_name) ?
                                  (
                                    <Mrp placeorderedit={this.props.placeorderedit} viewDisplay='none'
                                         partcodeOption={this.props.partcodeOption}
                                         aliasId={c.partno} brand_id={c.brand_id} />
                                  ) : ''
                                }
                              </td>
                              <td>
                                <center>
                                  { (c.spare_name) ?
                                    (<Input type='number' onChange={this.stockchange(m.id)} fluid value={m.qty} />) : ''
                                  }
                                </center>
                              </td>
                              <td>
                                <center>
                                { (c.spare_name) ?
                                  (<Checkbox onChange={this.handleChange(m.id)} checked={m.checkbox} />) : ''
                                }
                                </center>
                              </td>
                            </tr>
                          )
                        }
                      })
                    }
                  </tbody>
                )
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            { this.state.checkBox.length >= 1 ?
              (
                <div>
                  <Button style={{display: 'none'}} onClick={this.generatequotation.bind(this)}>Genarate Quotation</Button>
                  <Button onClick={ () => { this.setState({ openChangeStatus: true }) }}>Change Status</Button>
                </div>
              ) : ''
            }
            <Button onClick={ () => { this.setState({ open: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>

        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth1}  open={this.state.openChangeStatus}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Change Status</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <List>
                  <ListItem id='pointer' onClick={this.changeStatus.bind(this, 'Waiting')} style={{fontSize: 14}}><b>Waiting</b></ListItem>
                  <ListItem id='pointer' onClick={this.changeStatus.bind(this, 'Approved')} style={{fontSize: 14}}><b>Approved</b></ListItem>
                  <ListItem id='pointer' onClick={this.changeStatus.bind(this, 'Prior Order')} style={{fontSize: 14}}><b>Prior Order</b></ListItem>
                  <ListItem id='pointer' onClick={this.changeStatus.bind(this, 'Canceled')} style={{fontSize: 14}}><b>Canceled</b></ListItem>
                </List>
              </DialogContentText>
            </DialogContent>
            <DialogActions><Button onClick={ () => { this.setState({ openChangeStatus: false }) }}>Close</Button></DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Title;
